const useMediators = () => {
    const getMediators = () => {
        return [
            { value: process.env.REACT_APP_CRIZAL_SSOID, label: process.env.REACT_APP_CRIZAL_NAME},
            { value: process.env.REACT_APP_DISEASE_SSOID, label: process.env.REACT_APP_DISEASE_NAME},
            { value: process.env.REACT_APP_EYEZEN_SSOID, label: process.env.REACT_APP_EYEZEN_NAME},
            { value: process.env.REACT_APP_STELLEST_SSOID, label: process.env.REACT_APP_STELLEST_NAME},
            { value: process.env.REACT_APP_TRANSITIONS_SSOID, label: process.env.REACT_APP_TRANSITIONS_NAME},
            { value: process.env.REACT_APP_VARILUX_SSOID, label: process.env.REACT_APP_VARILUX_NAME}
            // { value: process.env.REACT_APP_MYOPIA_SSOID, label: process.env.REACT_APP_MYOPIA_NAME},
            // { value: process.env.REACT_APP_PRESBYPIA_SSOID, label: process.env.REACT_APP_PRESBYPIA_NAME},
            // { value: process.env.REACT_APP_LIGHT_MANAGEMENT_SSOID, label: process.env.REACT_APP_LIGHT_MANAGEMENT_NAME},
            // { value: process.env.REACT_APP_REFRACTION_SSOID, label: process.env.REACT_APP_REFRACTION_NAME},
            // { value: process.env.REACT_APP_GENERAL_EYE_DISEASE_SSOID, label: process.env.REACT_APP_GENERAL_EYE_DISEASE_NAME},
            // { value: process.env.REACT_APP_MEASURING_DEVICES_SSOID, label: process.env.REACT_APP_MEASURING_DEVICES_NAME},
            // { value: process.env.REACT_APP_INSTRUMENTS_SSOID, label: process.env.REACT_APP_INSTRUMENTS_NAME}
        ]
    }
    return [getMediators];
}

export default useMediators;
